import React from 'react';
import NavBar from './navBar';
import Grill from './grill';
import Footer from './footer';
import './mobile.css'




function mobile() {
  return (
    <div className="Mobile">
    <NavBar />
    <Grill />
    <Footer />
    </div>
  );
}

export default mobile;
